import { api, createTRPCLinks } from "./shared";
import { createQueryClient } from "./query-client";

export { api, type RouterInputs, type RouterOutputs } from "./shared";

export function createTRPCClient() {
  return api.createClient({
    links: createTRPCLinks("vite-react"),
  });
}

export { createQueryClient };
